module.exports = __webpack_public_path__ + "img/MTR.3286b7db.svg";